module.exports = __webpack_public_path__ + "static/nasa1-frame-0e16506c64c5f6078a1d88d740407cbf.gif";